export default __webpack_public_path__ + "static/php-ad47badf01d74ea2eb13ffec958ffeb7.png";